import {fetchPoll} from '@github-ui/fetch-utils'
import memoize from '@github/memoize'
// eslint-disable-next-line no-restricted-imports
import {observe} from '@github/selector-observer'
import renderDashboardsOverviewGraph from './graphs/dashboards-overview'
import {throttle} from '@github/mini-throttle'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Data = any

const cachedData = memoize(fetchData)

async function fetchData(url: string): Promise<Data> {
  const response = await fetchPoll(url, {headers: {accept: 'application/json'}})
  return await response.json()
}

async function renderGraph(graph: HTMLElement) {
  const url = graph.getAttribute('data-url')
  if (!url) {
    return
  }

  // Remove possibly existing cached graph.
  for (const el of graph.querySelectorAll('svg.viz')) {
    el.remove()
  }

  graph.classList.add('is-graph-loading')
  graph.classList.remove('is-graph-load-error', 'is-graph-empty')

  try {
    const data = await cachedData(url)
    if (!document.contains(graph)) return
    graph.classList.remove('is-graph-loading')
    if (data != null && data.unusable) {
      graph.classList.add('is-graph-without-usable-data')
    } else if (
      (data != null && data.length === 0) ||
      (data != null && data.summary != null && data.summary.total === 0) ||
      (data[0] != null && data[0].weeks != null && data[0].weeks.length === 0)
    ) {
      graph.classList.add('is-graph-empty')
    } else {
      render(graph, data)
    }
  } catch (error) {
    graph.classList.remove('is-graph-loading')
    graph.classList.add('is-graph-load-error')
    throw error
  }
}

function render(graph: HTMLElement, data: Data) {
  switch (graph.getAttribute('data-graph-name')) {
    case 'dashboards-overview': {
      renderDashboardsOverviewGraph(graph, data)
      break
    }
  }
}

observe('.js-graph', function (graph) {
  renderGraph(graph as HTMLElement)
  const isResponsiveGraph = graph.getAttribute('data-responsive-graph')
  if (isResponsiveGraph === 'true') {
    const throttledRender = throttle(renderGraph.bind(null, graph as HTMLElement), 100)
    return {
      add() {
        /* eslint-disable-next-line github/prefer-observers */
        window.addEventListener('resize', throttledRender)
      },
      remove() {
        window.removeEventListener('resize', throttledRender)
      },
    }
  }
})
